import React from "react";

export default function PackageDetailPage() {
  return (
    <div className="container mx-auto p-4 grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Main Content */}
      <div className="lg:col-span-2 space-y-6">
        {/* Header */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold">Romantic Paris Getaway</h1>
          <p className="text-gray-500">5 Nights • Paris, France</p>
          <div className="text-yellow-500">⭐⭐⭐⭐☆ (4.5)</div>
        </div>

        {/* Image */}
        <div className="rounded-xl overflow-hidden">
          <img
            src="https://i.pinimg.com/736x/09/22/3b/09223bade133549d8869878b9d8a1807.jpg"
            alt="Package"
            className="w-full h-64 object-cover"
          />
        </div>

        {/* Sections */}
        <div className="space-y-6">
          <Section title="Overview">
            <p>
              Experience the romance of Paris with a luxurious stay, guided city
              tours, and fine dining experiences. Perfect for couples or solo
              travelers looking to explore the beauty of the City of Lights.
            </p>
          </Section>

          <Section title="Itinerary">
            <ul className="list-disc pl-5 space-y-1">
              <li>Day 1: Arrival and Eiffel Tower visit</li>
              <li>Day 2: Louvre Museum and Seine River Cruise</li>
              <li>Day 3-5: Optional city tours and leisure time</li>
            </ul>
          </Section>

          <Section title="Inclusions">
            <ul className="list-disc pl-5 space-y-1">
              <li>4-star Accommodation</li>
              <li>Daily Breakfast</li>
              <li>Airport Pickup & Drop</li>
              <li>City Tour Pass</li>
            </ul>
          </Section>

          <Section title="Policies">
            <p>
              Free cancellation up to 7 days before departure. Reschedule
              available with 48-hour notice.
            </p>
          </Section>
        </div>
      </div>

      {/* Sidebar Booking Card */}
      <div className="lg:col-span-1">
        <div className="bg-white border border-gray-200 rounded-xl shadow-md p-6 sticky top-6">
          <div className="mb-4">
            <div className="text-2xl font-bold">$1,499</div>
            <p className="text-gray-500 text-sm">per person</p>
          </div>
          <button className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition">
            Book Now
          </button>
          <button className="w-full mt-2 border border-gray-300 py-2 rounded-md hover:bg-gray-100 transition">
            Contact Agent
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">{title}</h2>
      {children}
    </div>
  );
}
